import React from "react";
import { ScanFlowV2 } from "crossdock/common/flow/ScanFlowV2";
import { useFreightArrivalPage } from "./useFreightArrivalPage";

export const FreightArrival: React.FC = () => {
  const flowProps = useFreightArrivalPage();
  return <ScanFlowV2 {...flowProps} />;
};
